module.exports = __webpack_public_path__ + "img/image1.9915604c.jpg";